import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    whiteSpace: 'break-spaces',
  },
  link: {
    marginLeft: theme.spacing(0.375),
    fontSize: '14px',
    fontWeight: 500,
    fontStyle: 'normal',
    fontFamily: theme.typography.fontFamily,
    letterSpacing: '0.1px',
    lineHeight: '20px',
    cursor: 'pointer',
    color: theme.palette.labraText.description,
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  textWithCopy: {
    display: 'flex',
    gap: theme.spacing(0.5),
    alignItems: 'center',
  },
  linkWrapper: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    gap: theme.spacing(1),
  },
}))
